import React from 'react'
import { Box, Tooltip } from '@material-ui/core'
import { getStatusColor, getStatusName } from '../lib/utils'
import { EventSeat } from '@material-ui/icons'
import { SeatStatus } from 'config/constants'
import { getDescriptor } from 'views/utils/functions'

function Seat({
  row,
  rowDescriptor,
  column,
  columnDescriptor,
  status,
  onClick,
  onMouseDown,
  onMouseEnter
}) {
  const handleClick = () => {
    if (status === SeatStatus.Sold || status === SeatStatus.Reserved) return
    onClick(row, column)
  }

  const handleMouseDown = (e) => {
    e.preventDefault()
    if (onMouseDown) onMouseDown(row, column)
  }
  const handleMouseEnter = () => {
    if (onMouseEnter) onMouseEnter(row, column)
  }

  return (
    <Tooltip
      title={`Fila: ${getDescriptor(rowDescriptor, row)}, Columna: ${getDescriptor(columnDescriptor, column)}, Estado: ${getStatusName(status)}`}>
      <Box
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onMouseEnter={handleMouseEnter}
        sx={{
          width: 30,
          height: 30,
          overflow: 'hidden',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: getStatusColor(status),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor:
              status === SeatStatus.Sold || status === SeatStatus.Reserved
                ? 'default'
                : 'pointer',
            transition: 'all 0.2s',
            '&:hover': {
              transform: 'scale(1.1)',
              boxShadow: '0 0 5px rgba(0,0,0,0.2)'
            }
          }}>
          {status === SeatStatus.Empty ? (
            ''
          ) : (
            <EventSeat style={{ fontSize: '0.9rem' }} />
          )}
        </Box>
      </Box>
    </Tooltip>
  )
}

export default React.memo(
  Seat,
  (prev, next) =>
    prev.status === next.status &&
    prev.onMouseDown === next.onMouseDown &&
    prev.onMouseEnter === next.onMouseEnter
)
